import type { CurvaDocument } from "../model/document";

export const CURVA_FORMAT = "curva";
export const CURVA_SCHEMA_VERSION = 1;

export interface CurvaDocumentJson {
  format: typeof CURVA_FORMAT;
  version: typeof CURVA_SCHEMA_VERSION;
  document: CurvaDocument;
}

export interface CurvaMetadataJson {
  format: typeof CURVA_FORMAT;
  version: typeof CURVA_SCHEMA_VERSION;
  savedAt: string;
  generator: "curva";
}

export function toCurvaDocumentJson(document: CurvaDocument): CurvaDocumentJson {
  return {
    format: CURVA_FORMAT,
    version: CURVA_SCHEMA_VERSION,
    document,
  };
}
